import React from "react";
import styles from "./Layout.module.scss";
import image from "../../assets/images/blue-background-geometrical-shape.jpg";

const Layout = () => {
  return (
    <>
      <div className={styles.layout}>
        <img className={styles.image} src={image} alt="background" />
        <div className={styles.color}></div>
      </div>
      <nav className={styles.navbar}>
        <ul>
          <li>
            <a href="/departments">Departments</a>
          </li>
          <li>
            <a href="/admin/employeelist">Employee List</a>
          </li>
          <li>
            <a href="/admin/ptaskerror">PTask Error</a>
          </li>
          <li>
            <a href="/admin/adminlist">Admin List</a>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Layout;
